import moment from "moment";
import { icons } from "../../assets/icons";
import { displayDateFormat, canSendBackForRework, isVoucherInRework, canEditVoucherAfterRework, containsRework } from "../../utils/helpers";

export const adminColumns = ({ onClickDownloadFile, onEditClick, userLabel, voucherData }) => [
  {
    Header: "Date",
    accessor: "date",
    Cell: (props) => {
      return (
        <div>
          {moment(props?.row?.original?.date).format(displayDateFormat)}
        </div>
      );
    },
  },
  {
    Header: "Voucher Head",
    accessor: "head",
    Cell: (props) => {
      const value = props?.row?.original;

      return (
        <div className="py-4 max-w-[20rem]">
          <div
            className={`font-size-small ${
              props?.row?.subRows.length === 0 ? "font-family-regular" : ""
            }`}
          >
            {value?.head}
          </div>
          {/* {value?.sub_head ? (
            <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.sub_head}
            </div>
          ) : null} */}
        </div>
      );
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (props) => {
      const value = props?.row?.original?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return amount || "-";
    },
  },
  { Header: "Voucher Comment", accessor: "comment" },
  {
    Header: "L1 Status",
    accessor: "l1_status",
    Cell: (props) => {
      const value = props?.row?.original?.L1?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              :             value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    accessor: "l2_status",
    Cell: (props) => {
      const value = props?.row?.original?.L2?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              :             value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    accessor: "ac_status",
    Cell: (props) => {
      const value = props?.row?.original?.Finance?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              :             value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "Approved Amount (₹)",
    accessor: "approved_amount",
    Cell: (props) => {
      const value = props?.row?.original?.finance_amount_approved;
      return value ? Number(value).toFixed(2) : "-";
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: (props) => {
      const rowData = props?.row?.original;
      // Merge voucher data with row data to check rework status from both sources
      // Row data might have L1/L2/L3 status fields that indicate rework
      const voucherToCheck = {
        ...voucherData,
        ...rowData,
        // Ensure status fields from row are included
        L1: rowData?.L1 || voucherData?.L1,
        L2: rowData?.L2 || voucherData?.L2,
        L3: rowData?.L3 || voucherData?.L3,
        Finance: rowData?.Finance || voucherData?.Finance,
        newL1Status: rowData?.newL1Status || rowData?.L1?.status || voucherData?.newL1Status,
        newL2Status: rowData?.newL2Status || rowData?.L2?.status || voucherData?.newL2Status,
        newL3Status: rowData?.newL3Status || rowData?.L3?.status || voucherData?.newL3Status,
        // Finance status is stored in Finance.status (for A/C Status column)
        financeStatus: rowData?.Finance?.status || voucherData?.Finance?.status,
      };
      const canEdit = onEditClick && canEditVoucherAfterRework(voucherToCheck, userLabel);
      const hasFile = rowData?.filename;

      if (!hasFile && !canEdit) {
        return null;
      }

      return (
        <div className="flex items-center gap-x-7">
          {canEdit && (
            <img
              alt="edit icon"
              className="cursor-pointer"
              src={icons.editIcon}
              onClick={() => onEditClick(rowData)}
              title="Edit Voucher"
            />
          )}
          {hasFile && (
            <img
              alt="download icon"
              className="cursor-pointer"
              src={icons.downloadIcon}
              onClick={() =>
                onClickDownloadFile(
                  rowData?.file_id,
                  rowData?.filename
                )
              }
            />
          )}
        </div>
      );
    },
  },
];

export const areaManagerColumns = ({
  setIsModalVisible,
  approveRequestHandler,
  rejectRequestHandler,
  reworkRequestHandler,
  setIsEditApproveVisible,
  setIsRejectVisible,
  setIsSendBackForReworkVisible,
  getFile,
  type,
  inBetweenColumns = [],
  onClickDownloadFile,
  onClickViewFile,
  vid,
  userLabel,
  setIsEditVoucherCommentVisible,
  decisionStatusMap = {} // Track decision status per sub-voucher
}) => [
  {
    Header: "",
    accessor: "arrow",
    Cell: (props) => {
      if (!props?.row?.subRows?.length) {
        return null;
      }
      return (
        <div {...props.row?.getToggleRowExpandedProps()} className="w-[2rem]">
          <img
            src={props?.row?.isExpanded ? icons.arrowLeft : icons.arrowDown}
            alt="arrow down"
          />
        </div>
      );
    },
  },
  // {
  //   Header: "ID",
  //   accessor: "id",
  //   Cell: (props) => {
  //     return (
  //       <div className="">
  //         <div>{vid || "-"}</div>
  //       </div>
  //     );
  //   },
  // },
  {
    Header: "E.ID",
    Cell: (props) => {
      return (
        <div className="">
          <div>{props?.row?.original?.childId || "-"}</div>
        </div>
      );
    },
  },
  {
    Header: "Voucher Head",
    accessor: "head",
    Cell: (props) => {
      const value = props?.row?.original;

      return (
        <div className="py-4">
          <div
            className={`font-size-small ${
              props?.row?.subRows.length === 0 ? "font-family-regular" : ""
            }`}
          >
            {value?.head || value?.subhead}
          </div>
          {/* {value?.sub_head ? (
            <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.sub_head}
            </div>
          ) : value?.subheads ? (
            <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.subheads}
            </div>
          ) : value?.subhead ? (
            <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.subRows?.length} Invoices
            </div>
          ) : null} */}
        </div>
      );
    },
  },
  {
    Header: "Date",
    accessor: "date",
    Cell: (props) => {
      if (!props?.row?.original?.date) {
        return "-";
      }

      return (
        <div>
          {moment(props?.row?.original?.date).format(displayDateFormat)}
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (props) => {
      const value = props?.row?.original?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return <div className="text-center min-w-44">{amount || "-"}</div>;
    },
  },
  {
    Header: "L1 Status",
    Cell: (props) => {
      return (
        <div className="w-full min-w-44">
          <div
            className={
              props?.row?.original?.newL1Status === "Approved"
                ? "text-[var(--successGreen)] w-full"
                : props?.row?.original?.newL1Status === "Rejected"
                ? "text-[var(--textRed)] w-full"
                : props?.row?.original?.newL1Status === "Pending"
                ? "text-[var(--pendingYellow)] w-full"
                : props?.row?.original?.newL1Status === "Partially Approved"
                ? "text-[var(--pendingYellow)] w-full"
                : "w-full"
            }
          >
            {props?.row?.original?.newL1Status || (
              <div className="text-center">"-"</div>
            )}
          </div>
        </div>
      );
    },
  },
  {
    Header: "L1 Comment",
    Cell: (props) => {
      return (
        <div className="w-full min-w-44">
          {props?.row?.original?.newL1ActionComment || (
            <div className="text-center">-</div>
          )}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    Cell: (props) => {
      return (
        <div className="">
          <div className="">
            <div
              className={
                props?.row?.original?.newL2Status === "Approved"
                  ? "text-[var(--successGreen)]"
                  : props?.row?.original?.newL2Status === "Rejected"
                  ? "text-[var(--textRed)]"
                  : props?.row?.original?.newL2Status === "Pending"
                  ? "text-[var(--pendingYellow)]"
                  : props?.row?.original?.newL2Status === "Partially Approved"
                  ? "text-[var(--pendingYellow)]"
                  : containsRework(props?.row?.original?.newL2Status)
                  ? "text-[#FF8C00]"
                  : ""
              }
            >
              {props?.row?.original?.newL2Status || "-"}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    Header: "L2 Comment",
    Cell: (props) => {
      return (
        <div className="w-full min-w-44">
          {props?.row?.original?.newL2ActionComment || (
            <div className="text-center">-</div>
          )}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    Cell: (props) => {
      return (
        <div className="">
          <div className="">
            <div
              className={
                props?.row?.original?.newL3Status === "Approved"
                  ? "text-[var(--successGreen)]"
                  : props?.row?.original?.newL3Status === "Rejected"
                  ? "text-[var(--textRed)]"
                  : props?.row?.original?.newL3Status === "Pending"
                  ? "text-[var(--pendingYellow)]"
                  : props?.row?.original?.newL3Status === "Partially Approved"
                  ? "text-[var(--pendingYellow)]"
                  : containsRework(props?.row?.original?.newL3Status)
                  ? "text-[#FF8C00]"
                  : ""
              }
            >
              {props?.row?.original?.newL3Status || "-"}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    Header: "A/C Comment",
    Cell: (props) => {
      return (
        <div className="w-full min-w-44">
          {props?.row?.original?.newL3ActionComment || (
            <div className="text-center">-</div>
          )}
        </div>
      );
    },
  },
  ...inBetweenColumns,
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
    Cell: (props) => {
      if (type === "Approved") {
        const value =
          props?.row?.original?.finance_amount_approved ??
          props?.row?.original?.l2_amount_approved ??
          props?.row?.original?.l1_amount_approved;
        const num = value != null && value !== "" ? Number(value) : NaN;
        return <div>{!isNaN(num) ? num.toFixed(2) : "-"}</div>;
      }
      if (type === "All") {
        const value = props?.row?.original?.finance_amount_approved || "-";
        return (
          <div className="min-w-44 w-full text-center">
            {value !== "-" ? Number(value).toFixed(2) : value}
          </div>
        );
      } else {
        return <div className="min-w-44 w-full text-center">-</div>; // If type is not "Approved", don't render this column
      }
    },
  },
  {
    Header: "Voucher Comment",
    accessor: "comment",
    Cell: (props) => {
      return (
        <div className="w-full min-w-44">
          {props?.row?.original?.comment || (
              <div className="text-center">-</div>
            )}
          {userLabel === "Finance" && (
            <img
              src={icons.editIcon}
              alt="view icon"
              className="cursor-pointer w-6 h-6 mt-2 mb-2"
              onClick={() => {
                setIsEditVoucherCommentVisible(
                  {
                    isOpen: true,
                    data: {
                      id: props.row?.original?.id,
                      comment: props?.row?.original?.comment
                    }
                  }
                )  
              }}
            />
          )}
        </div>
      );
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: ({ row }) => {
      return (
        <div className="flex items-center justify-end gap-x-3 pr-6">
          {!row.subRows.length && type == "Rejected" && (
            <>
              <div className="text-[var(--textRed)]">Rejected</div>
            </>
          )}
          {/* Approved tab: show per-row status (Approved / Partially Approved / Rejected / Pending) like Rejected tab */}
          {!row.subRows.length && type == "Approved" && userLabel !== "Finance" && (
            (() => {
              const status = row?.original?.newL1Status || row?.original?.L1?.status || "Approved";
              const color =
                status === "Approved" ? "text-[var(--successGreen)]"
                : status === "Rejected" ? "text-[var(--textRed)]"
                : status === "Pending" ? "text-[var(--pendingYellow)]"
                : "text-[#FF8C00]"; // Partially Approved / Rework
              return <div className={color}>{status}</div>;
            })()
          )}
          {
            //Approved but Finance
            !row.subRows.length &&
              type == "Approved" &&
              userLabel == "Finance" && (
                <>
                  <img
                    src={icons.squareEyeIcon}
                    alt="view icon"
                    className="cursor-pointer"
                    onClick={() => {
                      onClickViewFile(
                        row?.original?.id,
                        row?.original?.filename
                      );
                    }}
                  />
                  <img
                    src={icons.downloadIcon}
                    alt="attachment icon"
                    className="cursor-pointer"
                    onClick={() => {
                      getFile(row?.original?.id, (data) => {
                        const url = window.URL.createObjectURL(
                          new Blob([data.data])
                        );
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = row?.original?.filename;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                      });
                    }}
                  />
                </>
              )
          }

          {(type === "Pending" || type === "All") && (
            <>
              {/* Show decision status badge if decision is made */}
              {decisionStatusMap[row?.original?.id] && (
                <div className={`text-sm font-medium ${
                  decisionStatusMap[row?.original?.id] === "Approved"
                    ? "text-[var(--successGreen)]"
                    : "text-[var(--textRed)]"
                }`}>
                  {decisionStatusMap[row?.original?.id]} (saved)
                </div>
              )}
              {needToShowActionButtons(row?.original, userLabel) && (
                <img
                  src={icons.editIcon}
                  alt="edit icon"
                  className="cursor-pointer"
                  onClick={() => {
                    const ids = [];
                    if (row?.original?.subRows) {
                      row?.original?.subRows?.forEach((row) => {
                        if (row?.id) {
                          ids.push({
                            id: row?.id,
                            approvedAmount:
                              row?.finance_amount_approved ||
                              row?.l2_amount_approved ||
                              row?.l1_amount_approved ||
                              row?.amount,
                            previousAm:
                              row?.finance_amount_approved ||
                              row?.l2_amount_approved ||
                              row?.l1_amount_approved ||
                              row?.amount,
                          });
                          return;
                        }

                        row?.subRows?.forEach((row) => {
                          if (row?.id) {
                            ids.push({
                              id: row?.id,
                              approvedAmount:
                                row?.finance_amount_approved ||
                                row?.l2_amount_approved ||
                                row?.l1_amount_approved ||
                                row?.amount,
                              previousAm:
                                row?.finance_amount_approved ||
                                row?.l2_amount_approved ||
                                row?.l1_amount_approved ||
                                row?.amount,
                            });
                            return;
                          }

                          row?.subRows?.forEach((row) => {
                            if (row?.id) {
                              ids.push({
                                id: row?.id,
                                approvedAmount:
                                  row?.finance_amount_approved ||
                                  row?.l2_amount_approved ||
                                  row?.l1_amount_approved ||
                                  row?.amount,
                                previousAm:
                                  row?.finance_amount_approved ||
                                  row?.l2_amount_approved ||
                                  row?.l1_amount_approved ||
                                  row?.amount,
                              });
                              return;
                            }
                          });
                        });
                      });
                    } else {
                      ids.push({
                        id: row?.original?.id,
                        approvedAmount:
                          row?.original?.finance_amount_approved ||
                          row?.original?.l2_amount_approved ||
                          row?.original?.l1_amount_approved ||
                          row?.original?.amount,
                        previousAm:
                          row?.original?.finance_amount_approved ||
                          row?.original?.l2_amount_approved ||
                          row?.original?.l1_amount_approved ||
                          row?.original?.amount,
                      });
                    }
                    setIsEditApproveVisible({
                      isOpen: true,
                      data: ids,
                      previousAmounts: ids,
                    });
                  }}
                />
              )}
              <img
                src={icons.downloadIcon}
                alt="attachment icon"
                className="cursor-pointer"
                onClick={() => {
                  getFile(row?.original?.id, (data) => {
                    const url = window.URL.createObjectURL(
                      new Blob([data.data])
                    );
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = row?.original?.filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                  });
                }}
              />
              <img
                src={icons.squareEyeIcon}
                alt="view icon"
                className="cursor-pointer"
                onClick={() => {
                  getFile(row?.original?.id, (data) => {
                    setIsModalVisible({ ...row?.original, file: data?.data });
                  });
                }}
              />
              {needToShowActionButtons(row?.original, userLabel) && 
                !decisionStatusMap[row?.original?.id] && (
                <img
                  src={icons.squareTickIcon}
                  alt="accept icon"
                  className="cursor-pointer"
                  onClick={() => {
                    const ids = [];
                    if (row?.original?.subRows) {
                      row?.original?.subRows?.forEach((row) => {
                        if (row?.id) {
                          ids.push(row?.id);
                          return;
                        }

                        row?.subRows?.forEach((row) => {
                          if (row?.id) {
                            ids.push(row?.id);
                            return;
                          }

                          row?.subRows?.forEach((row) => {
                            if (row?.id) {
                              ids.push(row?.id);
                              return;
                            }
                          });
                        });
                      });
                    } else {
                      ids.push(row?.original?.id);
                    }

                    approveRequestHandler([
                      {
                        id: ids[0],
                        approvedAmount:
                          row?.original?.finance_amount_approved ||
                          row?.original?.l2_amount_approved ||
                          row?.original?.l1_amount_approved ||
                          row?.original?.amount ||
                          "",
                      },
                    ], "", true); // saveDecisionOnly = true
                  }}
                />
              )}
              {needToShowActionButtons(row?.original, userLabel) && 
                !decisionStatusMap[row?.original?.id] && (
                <img
                  src={icons.squareTimesIcon}
                  alt="reject icon"
                  className="cursor-pointer"
                  onClick={() => {
                    const ids = [];
                    if (row?.original?.subRows) {
                      row?.original?.subRows?.forEach((row) => {
                        if (row?.id) {
                          ids.push(row?.id);
                          return;
                        }

                        row?.subRows?.forEach((row) => {
                          if (row?.id) {
                            ids.push(row?.id);
                            return;
                          }

                          row?.subRows?.forEach((row) => {
                            if (row?.id) {
                              ids.push(row?.id);
                              return;
                            }
                          });
                        });
                      });
                    } else {
                      ids.push(row?.original?.id);
                    }
                    setIsRejectVisible({ isOpen: true, data: ids });
                  }}
                />
              )}
              {canSendBackForRework(row?.original, userLabel) && setIsSendBackForReworkVisible && (
                <img
                  src={icons.loopIcon}
                  alt="send back for rework icon"
                  className="cursor-pointer"
                  style={{ filter: "hue-rotate(0deg) saturate(2)" }}
                  onClick={() => {
                    const ids = [];
                    if (row?.original?.subRows) {
                      row?.original?.subRows?.forEach((row) => {
                        if (row?.id) {
                          ids.push(row?.id);
                          return;
                        }

                        row?.subRows?.forEach((row) => {
                          if (row?.id) {
                            ids.push(row?.id);
                            return;
                          }

                          row?.subRows?.forEach((row) => {
                            if (row?.id) {
                              ids.push(row?.id);
                              return;
                            }
                          });
                        });
                      });
                    } else {
                      ids.push(row?.original?.id);
                    }
                    setIsSendBackForReworkVisible({ isOpen: true, data: ids });
                  }}
                />
              )}
            </>
          )}
        </div>
      );
    },
  },
];

// Statuses that mean "pending at L1" and should show Approve/Reject for L1 (including after resubmit)
const L1_PENDING_ACTION_STATUSES = ["Pending", "L1ApprovalPending", "RESUBMITTED"];

// Statuses that mean "pending at L2" and should show Approve/Reject for L2 (including after resubmit)
const L2_PENDING_ACTION_STATUSES = ["Pending", "L2ApprovalPending", "RESUBMITTED"];

// Statuses that mean "pending at L3/Finance" and should show Approve/Reject for Finance (including after resubmit)
const L3_PENDING_ACTION_STATUSES = ["Pending", "AccountsApprovalPending", "RESUBMITTED"];

function needToShowActionButtons(data, role) {
  // Don't show buttons if voucher is in rework
  if (isVoucherInRework(data)) {
    return false;
  }
  
  if(role === 'L1'){
    const l1Status = (data?.newL1Status || data?.L1?.status || "").trim();
    return L1_PENDING_ACTION_STATUSES.some((s) => s.toLowerCase() === l1Status.toLowerCase());
  }else if(role === 'L2'){
    // Check L2 status - should show buttons for pending states including RESUBMITTED
    const l2Status = (data?.newL2Status || data?.L2?.status || "").trim();
    
    // Check if voucher is already approved/rejected at L2 level
    const isApproved = l2Status && ["Approved", "Partially Approved", "ReworkApproved", "Rework Approved", "Partially Rework Approved"].some(
      s => s.toLowerCase() === l2Status.toLowerCase()
    );
    const isRejected = l2Status && l2Status.toLowerCase() === "rejected";
    
    // If already approved or rejected, don't show buttons
    if (isApproved || isRejected) {
      return false;
    }
    
    // Check if L1 is approved (voucher has passed L1 and is ready for L2)
    const l1Status = (data?.newL1Status || data?.L1?.status || "").trim();
    const l1IsApproved = l1Status && ["Approved", "Partially Approved", "ReworkApproved", "Rework Approved", "Partially Rework Approved"].some(
      s => s.toLowerCase() === l1Status.toLowerCase()
    );
    
    // Show buttons if:
    // 1. L1 is approved (voucher is ready for L2 review), AND
    // 2. L2 status is pending/resubmitted/empty (not yet decided at L2)
    if (l1IsApproved) {
      // If L2 status is empty/null, it's pending at L2
      if (!l2Status) {
        return true;
      }
      // If L2 status matches pending states
      if (L2_PENDING_ACTION_STATUSES.some((s) => s.toLowerCase() === l2Status.toLowerCase())) {
        return true;
      }
      // Also check for variations like "Resubmitted after rework" (might be in comment, but check status too)
      if (l2Status.toLowerCase().includes("resubmitted") || l2Status.toLowerCase().includes("pending")) {
        return true;
      }
    }
    
    return false;
  }else if(role === 'Finance'){
    // Check Finance/L3 status (A/C Status) - can be in newL3Status or Finance.status
    const financeStatus = (data?.newL3Status || data?.Finance?.status || "").trim();
    
    // Don't show buttons if L1 or L2 is rejected
    if (data?.newL1Status === "Rejected" || data?.newL2Status === "Rejected") {
      return false;
    }
    
    // Check if voucher is already approved/rejected at Finance level
    const isApproved = financeStatus && ["Approved", "Partially Approved", "ReworkApproved", "Rework Approved", "Partially Rework Approved"].some(
      s => s.toLowerCase() === financeStatus.toLowerCase()
    );
    const isRejected = financeStatus && financeStatus.toLowerCase() === "rejected";
    
    // If already approved or rejected, don't show buttons
    if (isApproved || isRejected) {
      return false;
    }
    
    // Check if L1 and L2 are approved (voucher has passed L1 and L2 and is ready for Finance)
    const l1Status = (data?.newL1Status || data?.L1?.status || "").trim();
    const l2Status = (data?.newL2Status || data?.L2?.status || "").trim();
    const l1IsApproved = l1Status && ["Approved", "Partially Approved", "ReworkApproved", "Rework Approved", "Partially Rework Approved"].some(
      s => s.toLowerCase() === l1Status.toLowerCase()
    );
    const l2IsApproved = l2Status && ["Approved", "Partially Approved", "ReworkApproved", "Rework Approved", "Partially Rework Approved"].some(
      s => s.toLowerCase() === l2Status.toLowerCase()
    );
    
    // Show buttons if:
    // 1. L1 and L2 are approved (voucher is ready for Finance review), AND
    // 2. Finance status is pending/resubmitted/empty (not yet decided at Finance)
    if (l1IsApproved && l2IsApproved) {
      // If Finance status is empty/null, it's pending at Finance
      if (!financeStatus) {
        return true;
      }
      // If Finance status matches pending states
      if (L3_PENDING_ACTION_STATUSES.some((s) => s.toLowerCase() === financeStatus.toLowerCase())) {
        return true;
      }
      // Also check for variations like "Resubmitted after rework" (might be in comment, but check status too)
      if (financeStatus.toLowerCase().includes("resubmitted") || financeStatus.toLowerCase().includes("pending")) {
        return true;
      }
    }
    
    return false;
  }
  return false;
}
